import "./Footer.scss";
import { NewsletterSignup } from "./NewsletterSignup";
import { organization } from "../data/organization";
import { routeHref } from "../routes";
export function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
          <div className="site-footer__top">
              <div>
                  <h2>Oferă-i corpului tău<br/>șansa unui nou început!</h2>
              </div>
              <div className="site-footer__contact">
                  <strong>Scrie-ne</strong>
            <a href={`mailto:${organization.email}`}>{organization.email}</a>
            <span>{organization.name}</span>
            <span>CIF {organization.cif} · {organization.address}</span>
          </div>
        </div>
        <NewsletterSignup />
        <div className="site-footer__bottom">
          <strong>AUPPS · Personocrația</strong>
          <div className="site-footer__links">
            <a href={routeHref("/despre-noi")}>Asociația</a>
            <a href={routeHref("/ateliere")}>Ateliere</a>
            <a href={routeHref("/testimoniale")}>Povești</a>
            <a href={routeHref("/contact")}>Contact</a>
            <a href={routeHref("/politica-de-confidentialitate")}>Confidențialitate</a>
          </div>
          <a className="site-footer__support" href="https://formular230.ro/asociatia-pentru-promovarea-sanatatii-personocratia" target="_blank" rel="noreferrer">Redirecționează 3,5% gratuit din impozitul tău ↗</a>
        </div>
      </div>
    </footer>
  );
}
